import { Component } from "@angular/core";

@Component({
  selector: "bit-menu-divider",
  templateUrl: "./menu-divider.component.html",
  standalone: true,
})
export class MenuDividerComponent {}
